import { useEffect, useRef, useState } from 'react';
import { getNews } from '../services/api';
import { Link } from 'react-router-dom';

const cacheKey = 'blog_default_cache';

const Blog = () => {
  const sectionRef = useRef(null);
  const [articles, setArticles] = useState([]);
  const [meta, setMeta] = useState({});
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [sortBy, setSortBy] = useState('published_at');
  const [order, setOrder] = useState('desc');

  useEffect(() => {
    setLoading(true);
    const params = { page, per_page: 9, sort_by: sortBy, order };
    if (search) params.search = search;
    getNews(params).then(res => {
      const list = res.data || [];
      setArticles(list);
      setMeta(res.meta || {});
      setLoading(false);
      if (page === 1 && !search && sortBy === 'published_at' && order === 'desc') {
      }
    });
  }, [page, search, sortBy, order]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); }),
      { threshold: 0.1, rootMargin: '0px 0px -30px 0px' }
    );
    if (sectionRef.current) {
      const els = sectionRef.current.querySelectorAll('.rv');
      els.forEach(el => observer.observe(el));
      return () => els.forEach(el => observer.unobserve(el));
    }
  }, [articles]);

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    return d.toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' });
  };

  return (
    <section id="blog" ref={sectionRef}>
      <div className="wrap">
        <div className="blog-header rv">
          <div className="slide-index" style={{color:'var(--yd)'}}><span></span> Blog & News</div>
          <h2 className="heading">
            Latest <em>Articles</em>
          </h2>
          <p className="blog-subtitle">Stay updated with the latest news, insights, and industry updates from PT CITRA HERITAGE INDONESIA.</p>
        </div>

        {/* Search, Sort, Order */}
        <div className="blog-filters rv">
          <div className="blog-search-wrap">
            <svg className="blog-search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            <input
              type="text"
              className="blog-search-input"
              placeholder="Search articles..."
              value={search}
              onChange={(e) => { setSearch(e.target.value); setPage(1); }}
            />
          </div>
          <select className="blog-select" value={sortBy} onChange={(e) => { setSortBy(e.target.value); setPage(1); }}>
            <option value="published_at">Sort by Date</option>
            <option value="title">Sort by Title</option>
          </select>
          <select className="blog-select" value={order} onChange={(e) => { setOrder(e.target.value); setPage(1); }}>
            <option value="desc">Newest First</option>
            <option value="asc">Oldest First</option>
          </select>
        </div>

        {loading && articles.length === 0 ? (
          <div className="comp-loading">Loading...</div>
        ) : articles.length > 0 ? (
          <>
            {/* Featured / Latest Blog */}
            <Link to={`/blog/${articles[0].slug}`} className="blog-featured rv" key={articles[0].id}>
              <div className="blog-featured-img">
                {articles[0].featured_image ? (
                  <img src={articles[0].featured_image} alt={articles[0].title} />
                ) : (
                  <div className="blog-card-placeholder"><span>✍️</span></div>
                )}
              </div>
              <div className="blog-featured-body">
                <span className="blog-featured-badge">Latest</span>
                <span className="blog-card-date">{formatDate(articles[0].published_at)}</span>
                <h3 className="blog-featured-title">{articles[0].title}</h3>
                <p className="blog-featured-excerpt">{articles[0].excerpt || ''}</p>
                <span className="blog-card-link">Read More ↗</span>
              </div>
            </Link>

            {/* Grid */}
            {articles.length > 0 && (
              <div className="blog-grid rv">
                {articles.map((article, idx) => (
                  <Link to={`/blog/${article.slug}`} className="blog-card" key={article.id}>
                    <div className="blog-card-img">
                      {article.featured_image ? (
                        <img src={article.featured_image} alt={article.title} />
                      ) : (
                        <div className="blog-card-placeholder">
                          <span>✍️</span>
                        </div>
                      )}
                    </div>
                    <div className="blog-card-body">
                      {idx === 0 && <span className="blog-card-badge-latest">Latest</span>}
                      <span className="blog-card-date">{formatDate(article.published_at)}</span>
                      <h3 className="blog-card-title">{article.title}</h3>
                      <p className="blog-card-excerpt">{article.excerpt || ''}</p>
                      <span className="blog-card-link">Read More ↗</span>
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </>
        ) : (
          <div className="comp-empty rv">
            <p>No articles published yet.</p>
          </div>
        )}

        {meta.last_page > 1 && (
          <div className="comp-pagination rv">
            <button className="comp-page-btn" disabled={page <= 1} onClick={() => setPage(p => p - 1)}>
              ← Prev
            </button>
            <span className="comp-page-info">Page {meta.current_page} of {meta.last_page}</span>
            <button className="comp-page-btn" disabled={page >= meta.last_page} onClick={() => setPage(p => p + 1)}>
              Next →
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default Blog;
